var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fileupload"},[_c('label',{attrs:{"for":"btnFileSelect"}},[_vm._v(_vm._s(_vm.$t('btnFileSelect')))]),_c('input',{attrs:{"id":"btnFileSelect","type":"file","placeholder":"VRMファイル"},on:{"change":_vm.changeFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }